var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84689 0.116287C6.94874 0.0314542 7.08012 -0.00945836 7.21214 0.00254291C7.34415 0.0145442 7.46599 0.0784767 7.55089 0.180286L10.8839 4.18029C10.9278 4.23047 10.9612 4.28892 10.9822 4.3522C11.0032 4.41549 11.0113 4.48233 11.006 4.54879C11.0008 4.61526 10.9823 4.68 10.9517 4.73922C10.921 4.79844 10.8789 4.85093 10.8277 4.89362C10.7764 4.9363 10.7172 4.96831 10.6534 4.98776C10.5897 5.00721 10.5226 5.01371 10.4563 5.00687C10.39 5.00004 10.3257 4.98001 10.2673 4.94797C10.2088 4.91593 10.1573 4.87251 10.1159 4.82029L6.78289 0.820287C6.69805 0.718428 6.65714 0.587051 6.66914 0.455037C6.68114 0.323023 6.74508 0.201178 6.84689 0.116287Z",
    fill: "#0A0B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84689 8.88419C6.74508 8.79929 6.68114 8.67745 6.66914 8.54543C6.65714 8.41342 6.69805 8.28204 6.78289 8.18019L10.1159 4.18019C10.1573 4.12796 10.2088 4.08455 10.2673 4.0525C10.3257 4.02046 10.39 4.00043 10.4563 3.9936C10.5226 3.98677 10.5897 3.99327 10.6534 4.01272C10.7172 4.03217 10.7764 4.06417 10.8277 4.10686C10.8789 4.14954 10.921 4.20203 10.9517 4.26125C10.9823 4.32047 11.0008 4.38521 11.006 4.45168C11.0113 4.51814 11.0032 4.58498 10.9822 4.64827C10.9612 4.71155 10.9278 4.77001 10.8839 4.82019L7.55089 8.82019C7.46599 8.92199 7.34415 8.98593 7.21214 8.99793C7.08012 9.00993 6.94874 8.96902 6.84689 8.88419Z",
    fill: "#0A0B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.50024C10.5 4.63285 10.4473 4.76003 10.3536 4.8538C10.2598 4.94757 10.1326 5.00024 10 5.00024L0.5 5.00024C0.367392 5.00024 0.240214 4.94757 0.146446 4.8538C0.0526781 4.76003 -2.76522e-08 4.63285 -2.18557e-08 4.50024C-1.60592e-08 4.36764 0.0526781 4.24046 0.146446 4.14669C0.240214 4.05292 0.367392 4.00024 0.5 4.00024L10 4.00024C10.1326 4.00024 10.2598 4.05292 10.3536 4.14669C10.4473 4.24046 10.5 4.36764 10.5 4.50024Z",
    fill: "#0A0B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverBlackArrow);
export default __webpack_public_path__ + "static/media/hover_black_arrow.258a8376f59e5536111a481a94a680c1.svg";
export { ForwardRef as ReactComponent };